import Vue from 'vue'
import Vuex from 'vuex'
import cryptojs from 'crypto-js'
import chooseCompany from '../components/ChooseCompany/state'
import password from '../components/Password/state'
import punchTimelog from '../components/PunchTimelog/state'
import VuexPersistence from 'vuex-persist'
import register from '../components/Register/state'
import Cookies from 'js-cookie'
import {API} from "../services";
import swal from 'sweetalert2'
import router from '../router/router'
import { getComManInfo } from '../utils'
import createPersistedState from 'vuex-persistedstate'

// TODO, state > cookie > local = fallback

Vue.use(Vuex)

export const persistentKey = 'vuex-persistent'

export const persistor = new VuexPersistence({
  key: 'web',
  modules: ['accessData', 'visualConfigs'],
  saveState: (key, state) => {
    const myKey = getComManInfo(persistentKey) || 'vuexnobodycares'
    const encrypted = cryptojs.AES.encrypt(
      JSON.stringify(state),
      myKey
    )
    return window.localStorage.setItem('vuex6' + myKey, encrypted)
  },
  getState: () => {
    const myKey = getComManInfo(persistentKey) || 'vuexnobodycares'
    const bytes = cryptojs.AES.decrypt(window.localStorage.getItem('vuex6' + myKey), myKey)
    return JSON.parse(bytes.toString(cryptojs.enc.Utf8))
  }
})

function defaultState () {
  return {
    executingSAMLLogin: false,
    accessData: {
      compMan: null,
      browserRecord: null,
      cognitoInfo: null,
      solarInfo: null
    },
    visualConfigs: null
  }
}

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      'key': 'web',
      'paths': ['accessData', 'visualConfigs']
  }), persistor.plugin],
  state: defaultState(),
  getters: {
    visual: function (state) {
      return state.visualConfigs ? state.visualConfigs.visual : {}
    }
  },
  mutations: {
    resetData (state) {
      Object.assign(state, defaultState())
    },
    setCompMan (state, {id, name, displayedName, logo}) {
      state.accessData.compMan = {
        id, name, displayedName, logo
      }
    },
    setBrowserRecord (state, {id, personal, employee, companies, recaptcha, style, active, comp_man, fallback}) {
      state.accessData.browserRecord = {
        id, personal, employee, companies, recaptcha, style, active, fallback
      }
      state.accessData.compMan = comp_man
    },
    _visualConfigs (state, {isDefault, visual, fileWeb}) {
      state.visualConfigs = {isDefault, visual, fileWeb}
    },
    cognitoInfo (state, payload) {
      state.accessData.cognitoInfo = {...(state.accessData.cognitoInfo || {}), ...payload}
    },
    solarInfo (state, payload) {
      state.accessData.solarInfo = {...(state.accessData.solarInfo || {}), ...payload}
      Cookies.set('Authorization', state.accessData.solarInfo.authorization)
    },
    executingSAMLLogin (state, payload) {
      state.executingSAMLLogin = Boolean(payload)
    }
  },
  actions: {
    async getBrowserRecordInfo ({ state, commit, dispatch }) {

      if (!state.accessData.browserRecord && !Cookies.get('id_browser')) {
        throw new Error('Theres no browser record')
      }

      try {

        let browserId = null;
        let ignoreMessage = true;

        if (state.accessData.browserRecord) {
          browserId = {id: state.accessData.browserRecord.id}
        } else {
          browserId = JSON.parse(Cookies.get('id_browser'))
          ignoreMessage = false;
        }

        const result = await API.device.get(browserId)
        commit('setBrowserRecord', result.body.success)

        if (Cookies.get('id_browser') && !ignoreMessage) {
          swal({
            type: 'success',
            text: 'Seja bem-vindo ao novo PontoTel Web',
            allowOutsideClick: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.value) {
              Cookies.remove('id_browser')
              router.push({name: 'password'})
            }
          })
        }
      } catch (e) {
        console.warn('Failed to update the browserRecord info')
        console.error(e)
        if (state.accessData && state.accessData.cognitoInfo && state.accessData.cognitoInfo.isSamlLogin) {
          router.push({name: 'punchTimelog'})
        } else if (state.accessData) {
          router.push({name: 'password'})
        } else {
          swal({
            type: 'warning',
            text: e.body.error,
            allowOutsideClick: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.value) {
              router.push({name: 'clear'})
            }
          })
        }
      }
    },
    async getVisual ({ state, commit, dispatch }, {reloadIfIsDefault=false, forceReload=false}) {

      // 1º Load the layout saved in backend
      if (!state.visualConfigs || forceReload === true || (state.visualConfigs.isDefault && reloadIfIsDefault === true)) {
        try {
          const result = await API.webVisual.get(
            state.accessData.browserRecord ? {id: state.accessData.browserRecord.id} : {}
          )

          commit('_visualConfigs', result.body.success)

        } catch (e) {
          if (state && state.visualConfigs && state.visualConfigs.visual !== "") {
          } else {
            const defaultJson = {
              fileWeb: 'https://s3.amazonaws.com/pontotel-styles-local/web/default.css',
              isDefault: true,
              visual: ""
            }
            commit('_visualConfigs', defaultJson)
          }
        }

        // 2º Load the css file
        dispatch('_getFileVisual',
          {fileUrl: state.visualConfigs.fileWeb, faviconUrl: state.visualConfigs.visual.favicon}
        )
      }

    },
    _getFileVisual ({}, {fileUrl, faviconUrl}) {
      // Load the custom style of comp_man/employer or the default one
      const customStyleContainerId = 'customStyleContainer'

      let container = document.getElementById(customStyleContainerId)
      let favicon = document.getElementById("favicon")

      if (container) {
        container.href = fileUrl
        favicon.href= faviconUrl
      } else if (!container) {
        container= document.createElement('link')
        container.href = fileUrl
        container.id = customStyleContainerId
        container.type = 'text/css'
        container.rel = 'stylesheet'
        document.getElementsByTagName('head')[0].append(container)
        favicon.href= faviconUrl
      }
    },
    async logout ({ state }) {

      if (!state.accessData.compMan) {
        localStorage.clear()
        window.location.href = window.location.origin
      }

      const compManId = state.accessData.compMan.id


      try {
        await API.logout.get()
      } catch (e) {}

      const result = await API.redirectSSORoute.get({compManId})

      function unicodeUnEscape(string) {
        return string.replace(/%u([\dA-Z]{4})|%([\dA-Z]{2})/g, function(_, m1, m2) {
          return String.fromCharCode(parseInt("0x" + (m1 || m2)));
        })
      }

      localStorage.clear()
      if (result.body && result.body.success && result.body.success.redirectWeb) {
        window.location.href = unicodeUnEscape(result.body.success.redirectWeb)
      } else {
        window.location.href = window.location.origin
      }
    },
    async clear ({ state }) {
      const compManId = state.accessData.compMan ? state.accessData.compMan.id : null
      const browserId = state.accessData.browserRecord ? state.accessData.browserRecord.id : null

      function unicodeUnEscape(string) {
        return string.replace(/%u([\dA-Z]{4})|%([\dA-Z]{2})/g, function(_, m1, m2) {
          return String.fromCharCode(parseInt("0x" + (m1 || m2)));
        })
      }
      if (compManId && browserId) {
        try {
          const remove = await API.browser.delete({fingerprint: browserId, compMan: compManId})
        } catch (e) {
          console.warn('error to remove browser ', e)
        }
      }

      localStorage.clear()

      if (compManId) {
        const result = await API.redirectSSORoute.get({compManId})

        if (result.body && result.body.success && result.body.success.redirectWeb) {
          window.location.href = unicodeUnEscape(result.body.success.redirectWeb)
        } else {
          window.location.href = window.location.origin
        }
      } else {
        window.location.href = window.location.origin
      }
    }
  },
  modules: {
    chooseCompany,
    password,
    punchTimelog,
    register
  }
})

window.vuex = store

export default store
